import { isInApp } from '@nio-wad/hooks'
import { isInMiniProgram } from './acrossAgent'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'

declare global {
  interface Window {
    container: string
    user_identity: string
  }
}
export const setContainer = () => {
  window.container = isInApp ? 'app' : isInMiniProgram() ? 'miniprogram' : 'h5'
}

export const setIdentity = () => {
  if (isInApp) {
    nioJsBridge.getUserInfo().then((userInfo) => {
      console.log('====================================')
      console.log('userInfo', userInfo)
      console.log('====================================')
      window.user_identity = userInfo?.data?.medal?.identity || ''
    })
  } else {
    window.user_identity = ''
  }
}

export const initTrackerParams = () => {
  setIdentity()
  setContainer()
}
